export default{
    reservas: [],
    reservas22: [],
    reservaSelec: null,
    materialesSelec: null,
    tarifasSelec: null,
   
}